import React, { useState, useEffect } from "react";
import {
  Grid,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  CircularProgress,
} from "@mui/material";

import axiosInterceptorInstance from "../../../utils/axios.interceptor";
import { motion } from "framer-motion";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const SyncProduct = () => {
  const [countryListN, setCountryListN] = useState<any[]>([]);
  const [perform, setPerform] = useState<boolean>(false);
  const [currency, setCurrency] = useState<any>("");
  const [country, setCountry] = useState<any>("0");
  const [vendor, setVendor] = useState<any>("");
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("user")) {
      var user = JSON.parse(localStorage.getItem("user") || "");
      if (
        user.Email == "tahir.shahzad@now.net.pk" ||
        user.Email == "rameez.hassan@now.net.pk"
      ) {
        navigate("/fusionhub/sync-product");
      } else {
        navigate("/support/portin");
      }
    }
  }, []);

  const loadCountries = async () => {
    await fetch("/data/thacountry.json")
      .then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error " + response.status);
        }
        return response.json();
      })
      .then((json: any) => {
        setCountryListN(json.thacountries);
      });
  };

  useEffect(() => {
    loadCountries();
  }, []);

  const getProductData = () => {
    toast.dismiss();
    if (
      country !== "0" &&
      country !== undefined &&
      vendor !== "" &&
      currency !== ""
    ) {
      syncProduct();
    } else {
      toast.error("Please Select Required Fields");
    }
  };

  const allCurrencies = [
    { value: "USD", label: "USD" },
    { value: "GBP", label: "GBP" },
    { value: "EUR", label: "EUR" },
  ];

  const filteredCurrencies =
    vendor === "2"
      ? allCurrencies.filter((c) => c.value === "USD")
      : vendor === "3"
      ? allCurrencies.filter((c) => c.value === "GBP" || c.value === "EUR")
      : allCurrencies;

  const syncProduct = async () => {
    setPerform(true);
    await axiosInterceptorInstance
      .post(`FusionHubCrm/SyncProducts`, {
        currencyCode: currency,
        countryIsoCode: country.isoCode2,
        vendorId: Number(vendor),
      })
      .then((res: any) => {
        const data = res.data;

        setPerform(false);
        toast.success(data.message);
      })
      .catch((error: any) => {
        setPerform(false);
      });
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div className="boxShadow">
        <h2 className="sectionTitle">Sync Product</h2>
        <div className="boxInner">
          <Grid container spacing={2}>
            {/* Form Controls */}
            <Grid item xs={12}>
              <fieldset>
                <legend>Actions:</legend>

                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <FormControl style={{ width: "100%" }}>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ background: "#fff", padding: " 0 5px" }}
                      >
                        Choose Vendor
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        className="formControl"
                        autoWidth
                        value={vendor}
                        defaultValue={vendor}
                        onChange={(e: any) => {
                          setVendor(e.target.value);
                          setCurrency("");
                        }}
                      >
                        <MenuItem value="1">DTOne</MenuItem>
                        <MenuItem value="2">Reloadly</MenuItem>
                        <MenuItem value="3">Ding</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={4}>
                    {countryListN && (
                      <FormControl style={{ width: "100%" }}>
                        <InputLabel
                          id="demo-simple-select-label"
                          style={{ background: "#fff", padding: " 0 5px" }}
                        >
                          Countries
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          className="formControl"
                          autoWidth
                          value={country?.isoCode2 || 0}
                          defaultValue={country?.isoCode2 || 0}
                          onChange={(e: any) => {
                            const country = countryListN?.find(
                              (item) => item.isoCode2 === e.target.value
                            );
                            setCountry(country);
                          }}
                        >
                          <MenuItem value="0">Select Country</MenuItem>
                          {countryListN.map((item, index) => (
                            <MenuItem key={index} value={item?.isoCode2}>
                              {item?.countryName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  </Grid>
                  <Grid item xs={4}>
                    <FormControl fullWidth>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ background: "#fff", padding: " 0 5px" }}
                      >
                        Choose Currency
                      </InputLabel>
                      <Select
                        value={currency}
                        onChange={(e) => setCurrency(e.target.value)}
                      >
                        {/* <MenuItem value="">Choose Currency</MenuItem> */}

                        {filteredCurrencies.map((currency) => (
                          <MenuItem key={currency.value} value={currency.value}>
                            {currency.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid>
                  {!perform && (
                    <Button
                      variant="contained"
                      className="perform1"
                      onClick={getProductData}
                      sx={{
                        margin: "0 auto",
                        display: "block",
                        width: "280px !important",
                      }}
                    >
                      Submit
                    </Button>
                  )}
                  {perform && (
                    <Button
                      className="perform1"
                      variant="contained"
                      sx={{
                        margin: "0 auto",
                        display: "block",
                        width: "280px !important",
                      }}
                    >
                      <CircularProgress color="inherit" size={15} />
                    </Button>
                  )}
                </Grid>
              </fieldset>
            </Grid>
          </Grid>
        </div>
      </div>
    </motion.div>
  );
};
export default SyncProduct;
